(() => {
'use strict';
const root=document.querySelector('[data-mf-jersey]');
if(!root||root.dataset.mfRunning==='2')return;
root.dataset.mfRunning='2';
const $=s=>root.querySelector(s), $$=s=>Array.from(root.querySelectorAll(s));
const productId='10842302906715',variantId=root.dataset.variant;
const cv=$('[data-preview]'),g=cv.getContext('2d'),W=cv.width,H=cv.height;
const keys=['front','back','leftSleeve','rightSleeve','leftPanel','rightPanel'];
const label={front:'Vorderseite',back:'Rückseite',leftSleeve:'Linker Ärmel',rightSleeve:'Rechter Ärmel',leftPanel:'Linkes Seitenteil',rightPanel:'Rechtes Seitenteil'};
const bounds={front:{x:360,y:463,w:284,h:528},back:{x:360,y:463,w:284,h:528},leftSleeve:{x:158,y:253,w:135,h:158},rightSleeve:{x:562,y:253,w:135,h:158},leftPanel:{x:239,y:498,w:44,h:452},rightPanel:{x:481,y:498,w:44,h:452}};
const state=Object.fromEntries(keys.map(k=>[k,{mode:'base',color:'#15191f',text:'',textX:bounds[k].x,textY:bounds[k].y,textSize:k.includes('Sleeve')?17:k.includes('Panel')?22:34,textFont:'Arial, sans-serif',textColor:'#d9252d',textRotation:k==='leftPanel'?-90:k==='rightPanel'?90:0,dragLayer:'text',file:null,image:null,x:bounds[k].x,y:bounds[k].y,scale:.7,rotation:0,cover:false}]));
const global={base:'#15191f',accent:'#d9252d',pantone:'',team:'',name:'',number:''};
const tiers=[65,63,59,56,54,52,50,47,45,42,40,39.95],eur=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'});
let selected='front',method='design',drag=null;
const msg=(s,ok=false)=>{const n=$('[data-status]');n.textContent=s;n.style.color=ok?'#a1f3bc':'#ffd29b';};
const normColor=(v)=>{
 let s=String(v||'').trim(),m;
 if(/^#([0-9a-f]{3})$/i.test(s))return '#'+s.slice(1).split('').map(x=>x+x).join('').toLowerCase();
 if(/^#[0-9a-f]{6}$/i.test(s))return s.toLowerCase();
 m=/^rgb\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i.exec(s);
 if(m&&m.slice(1).every(x=>+x<=255))return '#'+m.slice(1).map(x=>(+x).toString(16).padStart(2,'0')).join('');
 return null;
};
const mix=(hex1,hex2,t)=>{const f=h=>[1,3,5].map(i=>parseInt(h.slice(i,i+2),16));const a=f(hex1),b=f(hex2);return '#'+a.map((x,i)=>Math.round(x+(b[i]-x)*t).toString(16).padStart(2,'0')).join('');};
const color=k=>{let a=state[k];return a.mode==='accent'?global.accent:a.mode==='custom'?a.color:global.base;};
function priceUpdate(){let n=parseInt(document.querySelector('product-info[data-product-id="'+productId+'"] input.quantity__input[name="quantity"]')?.value||'1',10);if(!Number.isFinite(n)||n<1)n=1;const p=tiers[Math.min(n,12)-1];$('[data-unit-price]').textContent=eur.format(p);$('[data-total-price]').textContent=eur.format(Math.round(n*p*100)/100);$('[data-order-qty]').textContent='('+n+' Stück)';}
const qty=()=>{let n=parseInt(document.querySelector('product-info[data-product-id="'+productId+'"] input.quantity__input[name="quantity"]')?.value||'1',10);return Number.isFinite(n)?Math.max(1,n):1;};
function pathFor(key) {
 const p=new Path2D();
 if(key==='front'||key==='back'){
  p.moveTo(207,275);p.bezierCurveTo(213,215,229,162,289,126);p.quadraticCurveTo(323,109,360,151);p.quadraticCurveTo(397,109,431,126);p.bezierCurveTo(491,162,507,215,513,275);p.lineTo(519,741);p.quadraticCurveTo(360,766,201,741);p.closePath();
 }else if(key==='leftSleeve'){
  p.moveTo(289,126);p.quadraticCurveTo(255,126,222,154);p.lineTo(78,225);p.quadraticCurveTo(71,231,78,246);p.lineTo(139,345);p.quadraticCurveTo(148,350,162,342);p.lineTo(219,301);p.quadraticCurveTo(226,205,289,126);p.closePath();
 }else if(key==='rightSleeve'){
  p.moveTo(431,126);p.quadraticCurveTo(465,126,498,154);p.lineTo(642,225);p.quadraticCurveTo(649,231,642,246);p.lineTo(581,345);p.quadraticCurveTo(572,350,558,342);p.lineTo(501,301);p.quadraticCurveTo(494,205,431,126);p.closePath();
 }else if(key==='leftPanel'){
  p.moveTo(207,280);p.quadraticCurveTo(227,299,265,312);p.lineTo(260,739);p.quadraticCurveTo(230,742,201,741);p.closePath();
 }else if(key==='rightPanel'){
  p.moveTo(513,280);p.quadraticCurveTo(493,299,455,312);p.lineTo(460,739);p.quadraticCurveTo(490,742,519,741);p.closePath();
 }
 return p;
}
const paths=Object.fromEntries(keys.map(k=>[k,pathFor(k)]));
const grain=document.createElement('canvas');grain.width=180;grain.height=180;const gg=grain.getContext('2d');
const noise=gg.createImageData(180,180);for(let i=0;i<noise.data.length;i+=4){let shade=Math.round(112+Math.random()*110);noise.data[i]=shade;noise.data[i+1]=shade;noise.data[i+2]=shade;noise.data[i+3]=26;}gg.putImageData(noise,0,0);
const texture=g.createPattern(grain,'repeat');
const focus={
 front:{x:360,y:445,s:1},back:{x:360,y:445,s:1},
 leftSleeve:{x:177,y:268,s:1.4},rightSleeve:{x:543,y:268,s:1.4},
 leftPanel:{x:241,y:490,s:1.28},rightPanel:{x:479,y:490,s:1.28}
};
function clipping(c,k){c.clip(paths[k]);}
function sceneBackground(c){
 const b=c.createRadialGradient(355,270,10,360,430,520);b.addColorStop(0,'#77818d');b.addColorStop(.48,'#38434f');b.addColorStop(1,'#19222e');
 c.fillStyle=b;c.fillRect(0,0,720,850);
 c.fillStyle='rgba(255,255,255,.025)';for(let i=0;i<13;i++){c.fillRect(0,62*i,720,1);}
 c.beginPath();c.ellipse(364,784,242,35,0,0,Math.PI*2);c.fillStyle='rgba(0,0,0,.35)';c.fill();
}
function drawMaterial(c,k,preview){
 c.save();const p=paths[k];c.shadowColor=preview?'rgba(2,6,12,.64)':'transparent';c.shadowBlur=preview?23:0;c.shadowOffsetY=preview?12:0;c.fillStyle=color(k);c.fill(p);c.restore();
 if(preview){
  c.save();clipping(c,k);
  const b=bounds[k],h=c.createLinearGradient(b.x-b.w/1.6,0,b.x+b.w/1.5,0);
  h.addColorStop(0,'rgba(0,0,0,.30)');h.addColorStop(.14,'rgba(255,255,255,.13)');
  h.addColorStop(.35,'rgba(0,0,0,.04)');h.addColorStop(.58,'rgba(255,255,255,.065)');h.addColorStop(.83,'rgba(0,0,0,.11)');h.addColorStop(1,'rgba(0,0,0,.30)');
  c.fillStyle=h;c.fillRect(0,0,W,H);
  const v=c.createLinearGradient(0,120,0,760);v.addColorStop(0,'rgba(255,255,255,.11)');v.addColorStop(.23,'rgba(255,255,255,.00)');v.addColorStop(.66,'rgba(0,0,0,.06)');v.addColorStop(1,'rgba(0,0,0,.31)');c.fillStyle=v;c.fillRect(0,0,W,H);
  c.globalAlpha=.25;c.fillStyle=texture;c.fillRect(0,0,W,H);c.globalAlpha=1;
  if(k==='front'||k==='back'){
    for(let i=0;i<8;i++){
      const xx=260+i*29;c.beginPath();c.moveTo(xx,275);
      c.bezierCurveTo(xx-14,400,xx+12,570,xx-10,735);c.strokeStyle=i%2?'rgba(255,255,255,.021)':'rgba(0,0,0,.044)';c.lineWidth=4+i%3;c.stroke();
    }
    const crease=c.createLinearGradient(270,0,330,0);crease.addColorStop(0,'transparent');crease.addColorStop(.5,'rgba(0,0,0,.065)');crease.addColorStop(1,'transparent');c.fillStyle=crease;c.fillRect(275,295,55,390);
  }
  c.restore();
 }
}
function sleeveAccents(c,preview){
 c.save();const band=()=>{
  c.beginPath();c.moveTo(78,241);c.lineTo(139,345);c.quadraticCurveTo(149,351,163,341);c.lineTo(145,315);c.lineTo(88,221);c.closePath();c.fill();
  c.beginPath();c.moveTo(642,241);c.lineTo(581,345);c.quadraticCurveTo(571,351,557,341);c.lineTo(575,315);c.lineTo(632,221);c.closePath();c.fill();
 };
 c.fillStyle=global.accent;band();
 if(preview){c.strokeStyle='rgba(255,255,255,.3)';c.lineWidth=2;
 c.beginPath();c.moveTo(93,252);c.lineTo(146,336);c.moveTo(627,252);c.lineTo(574,336);c.stroke();}
 c.restore();
}
function collar(c,preview){
 c.save();
 c.beginPath();c.moveTo(289,123);c.bezierCurveTo(310,128,335,153,360,151);c.bezierCurveTo(385,153,410,128,431,123);
 c.lineTo(413,117);c.quadraticCurveTo(360,172,307,117);c.closePath();c.fillStyle=global.accent;c.fill();
 if(preview){c.strokeStyle='rgba(255,255,255,.45)';c.lineWidth=2.2;c.beginPath();c.moveTo(302,124);c.quadraticCurveTo(360,177,418,124);c.stroke();}
 c.restore();
}
function seamLines(c,preview){
 if(!preview)return;
 c.save();c.lineWidth=2;c.strokeStyle='rgba(255,255,255,.16)';
 for(let k of ['leftSleeve','rightSleeve','leftPanel','rightPanel'])c.stroke(paths[k]);
 c.beginPath();c.moveTo(290,134);c.quadraticCurveTo(255,178,224,301);c.moveTo(430,134);c.quadraticCurveTo(465,178,496,301);c.moveTo(207,741);c.quadraticCurveTo(360,761,513,741);c.stroke();
 c.setLineDash([2,5]);c.strokeStyle='rgba(0,0,0,.28)';c.lineWidth=2;
 c.beginPath();c.moveTo(252,320);c.lineTo(250,725);c.moveTo(468,320);c.lineTo(470,725);c.stroke();c.setLineDash([]);
 c.restore();
}
function drawImageArtwork(c,k){
 const a=state[k];if(!a.image)return;
 const b=bounds[k],im=a.image;
 c.save();
 c.translate(a.x,a.y);c.rotate(a.rotation*Math.PI/180);
 let w,h;
 if(a.cover){const factor=Math.max(b.w/im.width,b.h/im.height)*1.23;w=im.width*factor;h=im.height*factor;}
 else {let factor=Math.min(b.w*.80/im.width,b.h*.70/im.height)*a.scale/.7;w=im.width*factor;h=im.height*factor;}
 c.drawImage(im,-w/2,-h/2,w,h);c.restore();
}
function art(c,k){
 c.save();clipping(c,k);
 const b=bounds[k],a=state[k];
 drawImageArtwork(c,k);
 c.textAlign='center';c.textBaseline='middle';c.fillStyle=global.accent;
 if(k==='front'||k==='back'){
  if(global.team){c.font='800 27px Arial,sans-serif';c.fillText(global.team.toUpperCase().slice(0,29),360,k==='front'?250:246,320);}
  if(global.number){c.font='900 157px Arial Black,Arial,sans-serif';c.fillText(global.number,360,k==='front'?500:462,285);}
  if(k==='back'&&global.name){c.font='800 31px Arial,sans-serif';c.fillText(global.name.toUpperCase(),360,607,295);}
 }
 if(a.text){
   c.save();
   c.translate(a.textX,a.textY);
   c.rotate(a.textRotation*Math.PI/180);
   c.fillStyle=a.textColor;
   c.font='bold '+a.textSize+'px '+a.textFont;
   c.fillText(a.text,0,0,k.includes('Sleeve')?120:k.includes('Panel')?350:305);
   c.restore();
 }
 c.restore();
}
function drawView(c,k,preview){
 const body=k==='back'?'back':'front';
 if(preview)sceneBackground(c);
 c.save();
 if(preview){const f=focus[k];c.translate(360,418);c.scale(f.s,f.s);c.translate(-f.x,-f.y);}
 // Main body, then seam inserts, then sleeves on top – all share one cut silhouette.
 drawMaterial(c,body,preview);art(c,body);
 for(const part of ['leftPanel','rightPanel','leftSleeve','rightSleeve']){drawMaterial(c,part,preview);art(c,part);}
 sleeveAccents(c,preview);collar(c,preview);seamLines(c,preview);
 if(preview&&k!==body){
  const b=bounds[k];
  c.save();c.strokeStyle='rgba(255,173,68,.9)';c.lineWidth=3/focus[k].s;c.setLineDash([9,6]);c.stroke(paths[k]);c.restore();
 }
 c.restore();
}
const render=()=>{g.clearRect(0,0,W,H);drawView(g,selected,true);};
function syncAreaControls(){
 const a=state[selected];
 $('[data-panel-color-mode]').value=a.mode;
 $('[data-panel-custom-wrap]').hidden=a.mode!=='custom';
 $('[data-panel-custom-color]').value=a.color;
 $('[data-panel-custom-hex]').value=a.color.toUpperCase();
 $('[data-panel-text]').value=a.text;
 $('[data-text-font]').value=a.textFont;
 $('[data-text-color]').value=a.textColor;
 $('[data-text-color-hex]').value=a.textColor.toUpperCase();
 $('[data-text-size]').value=String(a.textSize);
 $('[data-text-size-out]').textContent=a.textSize+' px';
 $('[data-text-rotate]').value=String(a.textRotation);
 $('[data-text-rotate-out]').textContent=a.textRotation+'°';
 $('[data-drag-layer]').value=a.dragLayer;
 $('[data-art-scale]').value=String(Math.round(a.scale*100));
 $('[data-art-rotate]').value=String(a.rotation);
 $('[data-art-cover]').checked=a.cover;
 $('[data-art-file]').value='';
}
function select(k){
 if(!state[k])return;selected=k;
 $$('[data-side]').forEach(b=>{const on=b.dataset.side===k;b.classList.toggle('active',on);b.setAttribute('aria-selected',String(on));});
 $('[data-view-label]').textContent=label[k]+(k==='front'||k==='back'?'':' · Detailansicht');
 syncAreaControls();render();
}
function setMode(k){
 method=k;$$('[data-mode]').forEach(b=>{const on=b.dataset.mode===k;b.classList.toggle('active',on);b.setAttribute('aria-selected',String(on));});
 $$('[data-panel]').forEach(el=>{el.hidden=el.dataset.panel!==k;});
 $('[data-add-cart]').textContent=k==='design'?'MIT DESIGN IN DEN WARENKORB':'DRUCKDATEI IN DEN WARENKORB';msg('');
}
$$('[data-mode]').forEach(b=>b.addEventListener('click',()=>setMode(b.dataset.mode)));
$$('[data-side]').forEach(b=>b.addEventListener('click',()=>select(b.dataset.side)));
$$('[data-color]').forEach(input=>input.addEventListener('input',()=>{
 const k=input.dataset.color;global[k]=input.value.toLowerCase();
 $('[data-hex="'+k+'"]').value=global[k].toUpperCase();render();
}));
$$('[data-hex]').forEach(input=>input.addEventListener('change',()=>{
 const k=input.dataset.hex,v=normColor(input.value);
 if(!v){msg('Bitte einen HEX-Farbcode (#RRGGBB) oder rgb(R,G,B) eingeben.');input.value=global[k].toUpperCase();return;}
 global[k]=v;$('[data-color="'+k+'"]').value=v;input.value=v.toUpperCase();render();msg('');
}));
$('[data-pantone]').addEventListener('input',e=>{global.pantone=e.target.value;});
$$('[data-field]').forEach(input=>input.addEventListener('input',()=>{global[input.dataset.field]=input.value;render();}));
$('[data-panel-color-mode]').addEventListener('change',e=>{state[selected].mode=e.target.value;syncAreaControls();render();});
$('[data-panel-custom-color]').addEventListener('input',e=>{state[selected].color=e.target.value;$('[data-panel-custom-hex]').value=e.target.value.toUpperCase();render();});
$('[data-panel-custom-hex]').addEventListener('change',e=>{const v=normColor(e.target.value);if(!v){msg('Ungültiger Farbwert.');e.target.value=state[selected].color.toUpperCase();return;}state[selected].color=v;$('[data-panel-custom-color]').value=v;e.target.value=v.toUpperCase();render();msg('');});
$('[data-panel-text]').addEventListener('input',e=>{state[selected].text=e.target.value;state[selected].dragLayer='text';$('[data-drag-layer]').value='text';render();});
$('[data-text-font]').addEventListener('change',e=>{state[selected].textFont=e.target.value;render();});
$('[data-text-color]').addEventListener('input',e=>{state[selected].textColor=e.target.value;$('[data-text-color-hex]').value=e.target.value.toUpperCase();render();});
$('[data-text-color-hex]').addEventListener('change',e=>{
 const hex=normColor(e.target.value);if(!hex){msg('Bitte eine gültige Schriftfarbe als HEX oder RGB eingeben.');e.target.value=state[selected].textColor.toUpperCase();return;}
 state[selected].textColor=hex;$('[data-text-color]').value=hex;e.target.value=hex.toUpperCase();render();msg('');
});
$('[data-text-size]').addEventListener('input',e=>{const a=state[selected];a.textSize=+e.target.value;$('[data-text-size-out]').textContent=a.textSize+' px';render();});
$('[data-text-rotate]').addEventListener('input',e=>{const a=state[selected];a.textRotation=+e.target.value;$('[data-text-rotate-out]').textContent=a.textRotation+'°';render();});
$('[data-drag-layer]').addEventListener('change',e=>{state[selected].dragLayer=e.target.value;render();});
$('[data-art-scale]').addEventListener('input',e=>{state[selected].scale=+e.target.value/100;render();});
$('[data-art-rotate]').addEventListener('input',e=>{state[selected].rotation=+e.target.value;render();});
$('[data-art-cover]').addEventListener('change',e=>{state[selected].cover=e.target.checked;render();});
$('[data-art-remove]').addEventListener('click',()=>{const a=state[selected];a.file=null;a.image=null;$('[data-art-file]').value='';render();msg('Motiv aus '+label[selected]+' entfernt.',true);});
$('[data-art-file]').addEventListener('change',e=>{
 const file=e.target.files?.[0];if(!file)return;
 if(!/^image\/(png|jpeg|webp|svg\+xml)$/.test(file.type)){msg('Für die Vorschau PNG, JPG, WebP oder SVG verwenden.');return;}
 const key=selected,url=URL.createObjectURL(file),im=new Image();
 im.onload=()=>{URL.revokeObjectURL(url);const a=state[key];a.file=file;a.image=im;a.x=bounds[key].x;a.y=bounds[key].y;render();msg('Motiv auf '+label[key]+' übernommen.',true);};
 im.onerror=()=>{URL.revokeObjectURL(url);msg('Motiv konnte nicht dargestellt werden. Bitte PNG oder JPG probieren.');};
 im.src=url;
});
function point(e){const rect=cv.getBoundingClientRect(),x=(e.clientX-rect.left)*W/rect.width,y=(e.clientY-rect.top)*H/rect.height;const f=focus[selected];return {x:f.x+(x-360)/f.s,y:f.y+(y-418)/f.s};}
function isTextHit(p,a,k){
 if(!a.text)return false;
 g.save();g.font='bold '+a.textSize+'px '+a.textFont;
 const width=Math.min(g.measureText(a.text).width,k.includes('Sleeve')?120:k.includes('Panel')?350:305);
 g.restore();
 const rad=-a.textRotation*Math.PI/180,dx=p.x-a.textX,dy=p.y-a.textY;
 const rx=dx*Math.cos(rad)-dy*Math.sin(rad),ry=dx*Math.sin(rad)+dy*Math.cos(rad);
 return Math.abs(rx)<width/2+18&&Math.abs(ry)<a.textSize/2+17;
}
cv.addEventListener('pointerdown',e=>{
 const a=state[selected],p=point(e);
 if(!a.image&&!a.text)return;
 const layer=isTextHit(p,a,selected)?'text':a.dragLayer;
 if(layer==='text'&&!a.text)return;
 if(layer==='image'&&!a.image){if(!a.text)return;a.dragLayer='text';}
 else a.dragLayer=layer;
 $('[data-drag-layer]').value=a.dragLayer;
 drag={position:p,layer:a.dragLayer};
 cv.setPointerCapture(e.pointerId);e.preventDefault();
});
cv.addEventListener('pointermove',e=>{
 if(!drag)return;
 const p=point(e),a=state[selected],b=bounds[selected],dx=p.x-drag.position.x,dy=p.y-drag.position.y;
 if(drag.layer==='text'){
  a.textX=Math.max(b.x-b.w/2,Math.min(b.x+b.w/2,a.textX+dx));
  a.textY=Math.max(b.y-b.h/2,Math.min(b.y+b.h/2,a.textY+dy));
 }else{
  a.x=Math.max(b.x-b.w/2,Math.min(b.x+b.w/2,a.x+dx));
  a.y=Math.max(b.y-b.h/2,Math.min(b.y+b.h/2,a.y+dy));
 }
 drag.position=p;render();e.preventDefault();
});
['pointerup','pointercancel','lostpointercapture'].forEach(k=>cv.addEventListener(k,()=>drag=null));
function exportArea(k){
 return new Promise((resolve,reject)=>{
 const o=document.createElement('canvas');o.width=1800;o.height=2125;const c=o.getContext('2d');
 c.scale(2.5,2.5);drawMaterial(c,k,false);art(c,k);
 if(k==='front'||k==='back'){collar(c,false);}
 if(k.includes('Sleeve')){c.save();c.clip(paths[k]);sleeveAccents(c,false);c.restore();}
 o.toBlob(blob=>blob?resolve(new File([blob],'trikot-'+k+'-entwurf.png',{type:'image/png'})):reject(new Error('Gestaltungsentwurf konnte nicht exportiert werden.')),'image/png');
 });
}
async function uploadFiles(fd){
 const bridge=window.MFCloudliftOriginalBridge;
 if(typeof bridge?.uploadOriginal!=='function')throw new Error('Der Originaldatei-Upload ist derzeit nicht verfügbar. Bitte Shopbetreiber kontaktieren.');
 let n=0;
 for(const [key,val] of [...fd.entries()]){
  if(!(val instanceof File)||val.size<=0)continue;
  msg('Datei '+(++n)+' wird in Originalqualität hochgeladen …');
  const url=await bridge.uploadOriginal(val);
  if(!/^https:\/\//i.test(url))throw new Error('Für '+val.name+' wurde kein gültiger Datei-Link zurückgegeben.');
  fd.set(key,url);fd.set('properties[_MF Dateiname '+n+']',val.name);
 }
 if(!n)throw new Error('Bitte mindestens eine Druckdatei auswählen.');
 fd.set('properties[_MF Originalspeicher]','Cloudlift Originaldateien ('+n+')');
 fd.set('properties[_MF Originalzahl]',String(n));
}
function addForm(fd){
 return fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}}).then(async r=>{
   if(!r.ok){let t=await r.text();throw new Error('Warenkorb: '+r.status+' '+t.slice(0,160));}return r.json();
 });
}
async function add(){
 const btn=$('[data-add-cart]');btn.disabled=true;
 try{
  const fd=new FormData();fd.append('id',variantId);fd.append('quantity',String(qty()));
  fd.append('properties[_MF Designer]',method==='design'?'Teamsport 6-Bereiche-Designer':'Teamsport fertige Druckdatei');
  fd.append('properties[Gestaltungsart]',method==='design'?'Alle Trikotteile selbst gestalten':'Fertige Druckdatei hochladen');
  if(method==='ready'){
    let added=0;
    for(const k of keys){const file=$('[data-print-file="'+k+'"]').files?.[0];if(!file)continue;fd.append('properties[Original Kundenupload '+label[k]+']',file,file.name);added++;}
    if(!added)throw new Error('Bitte mindestens eine fertige Druckdatei auswählen.');
  }else{
    fd.append('properties[Grundfarbe HEX]',global.base.toUpperCase());
    fd.append('properties[Akzentfarbe HEX]',global.accent.toUpperCase());
    if(global.pantone)fd.append('properties[Pantone Referenz]',global.pantone);
    if(global.team)fd.append('properties[Teamname]',global.team);
    if(global.name)fd.append('properties[Spielername Muster]',global.name);
    if(global.number)fd.append('properties[Rückennummer Muster]',global.number);
    fd.append('properties[_MF Schnittmuster-Hinweis]','Gestaltungsentwürfe, keine fertigen Schnittdateien – Fertigung nach technischem Trikot-Schnitt.');
    const pack={version:2,model:'Merch-Fieber sublimation all-over design; illustrative garment geometry',baseHex:global.base,accentHex:global.accent,pantoneReference:global.pantone,team:global.team,name:global.name,number:global.number,areas:{}};
    for(const k of keys){
      const a=state[k],b=bounds[k];
      pack.areas[k]={hex:color(k),colorMode:a.mode,text:a.text,textStyle:{font:a.textFont,color:a.textColor,size:a.textSize,rotation:a.textRotation,x:a.textX,y:a.textY},imageOriginalName:a.file?.name||'',cover:a.cover,position:{x:a.x,y:a.y,scale:a.scale,rotation:a.rotation},referenceBounds:b};
      const out=await exportArea(k);
      fd.append('properties[_MF Gestaltungsentwurf '+label[k]+']',out,out.name);
      if(a.file)fd.append('properties[Original Motiv '+label[k]+']',a.file,a.file.name);
    }
    fd.append('properties[_MF Gestaltungsdaten]',new File([JSON.stringify(pack,null,2)],'teamsport-trikot-gestaltungsdaten.json',{type:'application/json'}));
  }
  await uploadFiles(fd);msg('Dateien gesichert, Warenkorb wird geöffnet …',true);
  await addForm(fd);window.location.assign('/cart');
 }catch(err){console.error('[Merch-Fieber Teamsport]',err);msg('Übertragung nicht abgeschlossen: '+(err?.message||'Unbekannter Fehler.'));}
 finally{btn.disabled=false;}
}
$('[data-add-cart]').addEventListener('click',add);
function interceptNormalBuy(){
 const info=document.querySelector('product-info[data-product-id="'+productId+'"]');
 const btn=info?.querySelector('button.product-form__submit');
 if(!btn||btn.dataset.mfTeamHook==='2')return;
 btn.dataset.mfTeamHook='2';btn.type='button';btn.removeAttribute('name');
 btn.textContent='TRIKOT GESTALTEN ODER DRUCKDATEI HOCHLADEN';
 btn.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();root.scrollIntoView({behavior:'smooth',block:'start'});},true);
}
const info=document.querySelector('product-info[data-product-id="'+productId+'"]');
interceptNormalBuy();
if(info)new MutationObserver(interceptNormalBuy).observe(info,{subtree:true,childList:true});
info?.addEventListener('change',priceUpdate);info?.addEventListener('click',()=>requestAnimationFrame(priceUpdate));
select('front');setMode('design');priceUpdate();
})();